import React from 'react'

export default function Patrimonial() {
  return (
    <div>
      Patrimonial
    </div>
  )
}
